import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Constants from 'common/constants'
import Utils from 'common/utils'
import Theme from 'common/theme'
import CommonComponents from 'components/commonComponents'
import NativeAgent from 'common/nativeAgent'
import LastUpdatedView from 'components/lastUpdatedView'
import LocationNotificationView from 'components/locationNotificationView';
import LocationFinder from 'components/locationFinder'
import SidebarBurger from './sidebarBurger';
import SidebarStateStore from 'stores/sidebarStateStore'
import DomUtils from 'common/domUtils'
import Analytics from 'analytics';
import ProgressiveImage from 'react-progressive-image'

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';
import 'styles/weather-view.css'
import 'moment-timezone';
import moment from 'moment';
import DataSource from 'common/dataStore'
import News from 'components/news/newsComponent';
import { Tabs, Tab } from '@material-ui/core';
import injectStyle from '../injectStyle'




const DEFAULT_ICON = "clear-day"

// const [value, setValue] = React.useState(0);


//const WEATHER_STATE = ["cloudy", "rain", "wind", "partly-cloudy-day", "partly-cloudy-night", "clear-night", "clear-day"];
const daysShortToFullMap = {
    "Fri": "Friday",
    "Sat": "Saturday",
    "Sun": "Sunday",
    "Mon": "Monday",
    "Tue": "Tuesday",
    "Wed": "Wednesday",
    "Thu": "Thursday"
};
const MAX_IMAGE_INDEX = 3;
const MIN_IMAGE_INDEX = 0;


export default class WeatherView extends Component {
    constructor(props) {
        super(props)
        this.firstLaunch = false;
        this.sunriseSunsetAnimationUpdateTimeOut = null;
        this.scrollableContentReference = React.createRef();
        this.scrollTop = 0
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.horizonStyle = {
            horizon: {
                WebkitAnimation: 'pulse 4s 1',
                WebkitAnimationFillMode: 'forwards'
            }
        }

        this.state = {
            isDailyState: true,
            showLocationPickerOverlay: false,
            showToolTip: props.show_tool_tip,
            indexOfImage: Math.floor(Math.random() * (MAX_IMAGE_INDEX - MIN_IMAGE_INDEX + 1)) + MIN_IMAGE_INDEX,
            shouldResetBackground: false,
            shouldAutomaticallyScroll: DataSource.getItem("has_user_manually_scrolled") === "yes" ? false : true,
            weatherNews: true,
            shouldExpandDailyData: false,
            shouldShowSunAnimation: false,
            frameStyle: null
        }
        this.toolTipRemovalHandlerTimeout = null;
        this.sunRiseSunSetTimer = null;
        this.__sidebarListener = SidebarStateStore.registerForStateChange(this.sidebarStatusHandler.bind(this))
    }

    componentDidUpdate(prevProps, prevState, snapShot) {
        console.log("component did update");
        if (prevProps.show_tool_tip !== this.props.show_tool_tip) {
            this.setState({
                showToolTip: this.props.show_tool_tip,
            });

        }

        if (false === Utils.isNull(this.props.last_refresh_time)) {
            var shouldUpdateRefreshMessage = true;
            if (false === Utils.isNull(prevProps.last_refresh_time)) {
                // Find difference in time
                var timeDiff = this.props.last_refresh_time - prevProps.last_refresh_time
                if (timeDiff <= Constants.MIN_REFRESH_TIME_DELTA_MS) {
                    shouldUpdateRefreshMessage = false
                } else {
                    console.log("REFRESH_ANIMATE: Time-diff - ", timeDiff)
                }
            }

            if (shouldUpdateRefreshMessage) {
                this.animateRefreshMessage();
            }
        }

        if (prevState.frameStyle !== this.props.frameStyle) {
            injectStyle(this.props.frameStyle);
            this.setState(currentState => {
                currentState.frameStyle = this.props.frameStyle;
                return currentState;
            });
        }

    }

    getMoonPhaseImage() {
        var moonPhase = this.props.daily_data[0]['moonPhase'];
        moonPhase = Math.round(moonPhase / 0.125) % 8
        var imagePath = '';
        if (moonPhase === 0) {
            imagePath = '/image/moon-images/new_moon.png';
        }
        else if (moonPhase === 1) {
            imagePath = '/image/moon-images/waxing_crescent.png';
        }
        else if (moonPhase === 2) {
            imagePath = '/image/moon-images/first_quarter.png';
        }
        else if (moonPhase === 3) {
            imagePath = '/image/moon-images/waxing_gibbous.png';
        }
        else if (moonPhase === 4) {
            imagePath = '/image/moon-images/full_moon.png';
        } else if (moonPhase === 5) {
            imagePath = '/image/moon-images/waning_gibbous.png';
        } else if (moonPhase === 6) {
            imagePath = '/image/moon-images/third_quarter.png';
        }
        else if (moonPhase === 7) {
            imagePath = '/image/moon-images/waning_crescent.png';
        }
        return imagePath;
    }

    getMoonPhaseText() {
        var moonPhase = this.props.daily_data[0]['moonPhase'];
        moonPhase = Math.round(moonPhase / 0.125) % 8
        var moonPhaseName = '';
        if (moonPhase === 0) {
            moonPhaseName = 'New Moon';
        }
        else if (moonPhase === 1) {
            moonPhaseName = 'Waxing Crescent';
        }
        else if (moonPhase === 2) {
            moonPhaseName = 'First Quarter';
        }
        else if (moonPhase === 3) {
            moonPhaseName = 'Waxing Gibbous';
        }
        else if (moonPhase === 4) {
            moonPhaseName = 'Full Moon';
        } else if (moonPhase === 5) {
            moonPhaseName = 'Waning Gibbous';
        } else if (moonPhase === 6) {
            moonPhaseName = 'Last Quarter';
        }
        else if (moonPhase === 7) {
            moonPhaseName = 'Waning Crescent';
        }
        return moonPhaseName;
    }

    componentDidMount() {
        this.componentIsDisplayed()
    }

    /**
     * Set the wrapper ref
     */
    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    listenScrollEvent(event) {
        const scrolledTop = this.scrollableContentReference.current.scrollTop
        NativeAgent.updatePullToRefresh(scrolledTop === 0)
        this.sendNonTappableAreaData();
        var topOfHorizon = DomUtils.getTopForElement("horizon-bg");
        this.srollTop = scrolledTop;
        if (scrolledTop > topOfHorizon) {
            this.setState({
                shouldShowSunAnimation: true
            })
        }
    }

    handleRedirectionToBilling = (action) => {
        NativeAgent.redirectToBilling()
        if(action){
            Analytics.sendEvent(
                Constants.ANALYTICS.EVENTS.CATEGORY.CLICK,
                action,
                Constants.ANALYTICS.EVENTS.LABEL.WEATHER_PAGE
            )
        }
    }

    removeAdsBar = (e) => {
        e.stopPropagation();
        DataSource.setItem(Constants.REMOVE_ADS_BAR, true)
        this.forceUpdate()
    }
    
    handleShareClick = (e) => {
        NativeAgent.sendShareWithFriendsCall()
        Analytics.sendEvent(
            Constants.ANALYTICS.EVENTS.CATEGORY.CLICK,
            Constants.ANALYTICS.EVENTS.ACTION.SHARE,
            Constants.ANALYTICS.EVENTS.LABEL.WEATHER_PAGE
        )
    }

    render() {
        console.log("render called: ");
        var currentData = this.props.current_data;
        if (typeof (currentData) === "undefined" || currentData === null) {
            currentData = {};
        }

        var bottomBarClass = "bottom-fix-with-bar"
        var appMainWrapperHeightClass = "amw-height-with-bottom-bar-nowv"
        var appMainWrapperTopbarMarginClass = "app-top-bar-margin"
        var overlayHeightClass = ""
        if (false === CommonComponents.shouldSetBottomBar()) {
            bottomBarClass = "bottom-fix-without-bar"
            appMainWrapperHeightClass = "amw-height-without-bottom-bar-nowv"
            overlayHeightClass = "amw-height-without-bottom-bar-nowv"
        }

        return (
            <div>
                {this.sendTempDetailsToClient()}
                {this.setupBackgroundImage()}

                <div className={`opacity-overlay-bg ${overlayHeightClass}`}>
                    {CommonComponents.getWeatherTopBarComponent()}

                    <div className={`app-main-wrapper ${appMainWrapperTopbarMarginClass} ${appMainWrapperHeightClass}`}>
                        <div className="top-bar">
                            <div className="top-bar-contents">
                                {this.props.showSearchBar && <div className="searchbar-wrapper">
                                    <a className="search-link" href="inapp://search-box">
                                        <input className="searchbar" placeholder='Search' readOnly/>
                                        <img className="search-icon" src="/image/topbar-serach-icon.svg" alt="search_icon" />
                                        {/* <img className="audio-icon" src="/image/topbar-audio-icon.svg" alt="audio_icon" /> */}
                                    </a>
                                </div>}
                                <div className="top-city-info-wrapper">
                                    <SidebarBurger
                                        on_click_cb={() => {
                                            this.props.open_side_bar_cb()
                                        }}
                                    />
                                    <div className="location-wrapper">
                                        <div className="location-content">
                                            {this.getCurrentLocationHtml(currentData)}
                                        </div>
                                    </div>
                                    <div
                                        className="search-wrap"
                                        onClick={() => {
                                            this.setState({
                                                showLocationPickerOverlay: true,
                                            })
                                        }}
                                    >
                                        <div>
                                            <img src="/image/plus-icon.svg" alt="plus_icon" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="parallax-effect-wrapper" ref={this.scrollableContentReference} onScroll={this.listenScrollEvent.bind(this)}>
                            <div className="app-top-half clearfix">
                                <div className="app-top-main-content">
                                    <div className="temperature-text-container">
                                        <div className="celsius-text align-center">
                                            <div className="temperature-text-content" onClick={this.handleCurrTempClick.bind(this)}>
                                                &zwnj;{currentData.currTemp}
                                                <span className="temperature-text-unit">
                                                    <span className="temperature-img-unit">
                                                        <img src={this.getTemperatureUnitImgFromData(currentData)} alt={currentData.temperatureUnit} />
                                                    </span>
                                                </span>
                                                &zwnj;
                                        </div>
                                        </div>
                                    </div>

                                    <div className="temperature-text-footnote">
                                        <div className="temp-footnote-content footnote-animation-commons">
                                            {currentData.iconPrettyPrint}, {currentData.maxTemp}˚{currentData.temperatureUnit} / {currentData.minTemp}˚{currentData.temperatureUnit}

                                        </div>
                                        <div className="temp-footnote-refresh-update footnote-animation-commons">
                                            Updated Weather
                                    </div>
                                    </div>
                                </div>
                            </div>
                            <div className="app-folds-wrap app-middle-half clearfix">
                                <div className="col-xs-12 temperature-text-description">
                                    <div className="row margin-wrap">
                                        <div className="col-lg-3 col-xs-3 col-3 temprature-blocks">
                                            <div className="weather-type-img-container">
                                                <img className="weather-icons" src="/image/climate-conditions/humidity.svg" alt="humidity" />
                                            </div>
                                            <div className="temprature-txt">Humidity</div>
                                            <div className="temprature-degree"><span>{currentData.humidity}%</span></div>
                                        </div>
                                        <div className="col-lg-3 col-xs-3 col-3 temprature-blocks">
                                            <div className=" weather-type-img-container">
                                                <img className="weather-icons" src="/image/climate-conditions/wind-speed.svg" alt="wind-speed" />
                                            </div>
                                            <div className="temprature-txt">Wind Speed</div>
                                            <div className="temprature-degree"><span>{currentData.windSpeed} {currentData.distanceUnit}</span></div>
                                        </div>
                                        <div className="col-lg-3 col-xs-3 col-3 temprature-blocks">
                                            <div className=" weather-type-img-container">
                                                <img className="weather-icons" src="/image/climate-conditions/cloud-cover.svg" alt="cloud-cover" />
                                            </div>
                                            <div className="temprature-txt">Cloud Cover</div>
                                            <div className="temprature-degree"><span>{currentData.cloudCover}%</span></div>
                                        </div>
                                        <div className="col-lg-3 col-xs-3 col-3 temprature-blocks">
                                            <div className=" weather-type-img-container">
                                                <img className="weather-icons" src="/image/climate-conditions/precipitation.svg" alt="precipitation" />
                                            </div>
                                            <div className="temprature-txt">Precipitation</div>
                                            <div className="temprature-degree"><span>{currentData.precipIntensity}%</span></div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-3 col-xs-3 col-3 temprature-blocks">
                                            <div className=" weather-type-img-container">
                                                <img className="weather-icons" src="/image/climate-conditions/feels-like.svg" alt="feels-like" />
                                            </div>
                                            <div className="temprature-txt">Feels Like</div>
                                            <div className="temprature-degree">{currentData.apparentTemp} &#176; {currentData.temperatureUnit}</div>
                                        </div>
                                        <div className="col-lg-3 col-xs-3 col-3 temprature-blocks">
                                            <div className="weather-type-img-container">
                                                <img className="weather-icons" src="/image/climate-conditions/pressure.svg" alt="pressure" />
                                            </div>
                                            <div className="temprature-txt">Pressure</div>
                                            <div className="temprature-degree"><span>{currentData.pressure} mb</span></div>
                                        </div>
                                        <div className="col-lg-3 col-xs-3 col-3 temprature-blocks">
                                            <div className=" weather-type-img-container">
                                                <img className="weather-icons" src="/image/climate-conditions/ozone.svg" alt="ozone" />
                                            </div>
                                            <div className="temprature-txt">Ozone</div>
                                            <div className="temprature-degree"><span>{currentData.ozone} Du</span></div>
                                        </div>
                                        <div className="col-lg-3 col-xs-3 col-3 temprature-blocks">
                                            <div className=" weather-type-img-container">
                                                <img className="weather-icons" src="/image/climate-conditions/uv-index.svg" alt="uv-index" />
                                            </div>
                                            <div className="temprature-txt">UV INDEX</div>
                                            <div className="temprature-degree"><span>{this.getUvIndexTestFor(currentData.uvIndex)}</span></div>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="col-xs-12 border-dash"></div> */}

                            </div>

                            {!this.props.isPremiumUser && this.props.showPremiumFeature && this.props.alertTitle && <div className="app-folds-wrap lightning-wrap clearfix">
                                <div className="lightning-wrap-left">
                                    <img className="lightning-image" src="/image/warning.svg" alt="lightning" />
                                    <span className="lightning-txt">{this.props.alertTitle}</span>
                                </div>
                                <div className="lightning-wrap-right" onClick={()=>this.handleRedirectionToBilling(Constants.ANALYTICS.EVENTS.ACTION.SHOW_MORE)}>
                                    <div className="show-more-btn"><span>SHOW MORE</span></div>
                                </div>
                            </div>}

                            {!this.props.isPremiumUser && this.props.ad_view}
                            
                            {/* This one also had app-bottom-half, I have removed this, the height was limited because of that  */}
                            <div className="app-folds-wrap forecast-wrapper clearfix">
                                <div className="app-folds-title">Forecast <span className="share-icon" id="share" onClick={this.handleShareClick}><img src="/image/share-icon-white.svg" alt="share icon" /></span></div>
                                <div className={"bottom-fix " + bottomBarClass}>
                                    <div className="table-wrapper" onScroll={this.onScrollListener.bind(this)}>
                                        <div className={(this.state.shouldAutomaticallyScroll && this.firstLaunch) ? "bottom-entries-table  scroll-bottom-table" : "bottom-entries-table"}>
                                            {this.getBottomEntriesHtml("hourly")}
                                            {!this.props.isPremiumUser && this.props.showPremiumFeature && 
                                            <div className="lock-unlock-border" onClick={()=>this.handleRedirectionToBilling(Constants.ANALYTICS.EVENTS.ACTION.ADDITIONAL_FORECAST)}>
                                                <div className="lock-unlock-btn-wrap">
                                                    <img className="lock-image" src="/image/ads-lock.svg" alt="lock" />
                                                    <span className="lock-txt">Get an additional 24 hours forecast</span>
                                                </div>
                                            </div>}
                                            {this.getBottomEntriesHtml("daily")}
                                        </div>
                                    </div>
                                </div>
                                <Tabs
                                    value={this.state.shouldExpandDailyData ? 1 : 0}
                                    onChange={this.handleDailyDataStateChange}
                                    className="table-info-tabs"
                                >
                                    <Tab label="5 Days" />
                                    <Tab label="8 Days" />
                                </Tabs>
                            </div>

                            {!this.props.isPremiumUser && this.props.showPremiumFeature && !DataSource.getItem(Constants.REMOVE_ADS_BAR) &&
                            <div className="app-folds-wrap ad-btn-wrapper clearfix">
                                <div className="col-xs-12">
                                    <div className="row">
                                        <div className="lock-unlock-btn-wrap remove-ads" onClick={()=>this.handleRedirectionToBilling(Constants.ANALYTICS.EVENTS.ACTION.REMOVE_ADS)}>
                                            <img className="close-btn" src="/image/ads-close.svg" alt="close" onClick={this.removeAdsBar}/>
                                            <span className="lock-txt">Remove ads</span>
                                        </div>
                                    </div>
                                </div>
                            </div>}

                            {!this.props.isPremiumUser && this.props.ad_view_large}

                            <div className="app-folds-wrap sunrise-sunset clearfix">
                                <div className="app-folds-title">Sun &amp; Moon</div>
                                <div className="row moon-placement-wrapper">
                                    <div className="moon-position-wrapper">
                                        <div className="moon-img"><img src={this.getMoonPhaseImage()} alt="moon position" /></div>
                                        <div className="moon-title">{this.getMoonPhaseText()}</div>
                                    </div>
                                    <div className="sunrise-sunset-img-graph" key={this.state.frameStyle}>
                                        <div className="horizon-main-wrapper">
                                            <div id="horizon">
                                                <div className="horizon-border"></div>
                                                <div className="horizon-bg" style={this.state.shouldShowSunAnimation === true ? this.horizonStyle.horizon : { "display": "none" }} >
                                                    <img className="sunrise-icon" src="/image/climate-icons/clear-day.svg" alt="" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="sunrise-sunset-time clearfix">
                                        <div className="col-lg-6 col-xs-6 col-6 align-right">
                                            <div className="sun-container">
                                                <div className="txt-time-wrap">
                                                    <div>Sunrise</div>
                                                    <div className="time-uppercase">{currentData.sunriseTime}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-xs-6 col-6 align-left">
                                            <div className="sun-container">
                                                <div className="txt-time-wrap">
                                                    <div>Sunset</div>
                                                    <div className="time-uppercase">{currentData.sunsetTime}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="app-folds-wrap weather-news-tabs-wrap clearfix">
                                <Tabs
                                    className="news-tabs"
                                    value={this.state.weatherNews ? 0 : 1}
                                    onChange={this.handleNewsTabChanged}
                                    centered
                                >
                                    <Tab label="WEATHER NEWS" />
                                    <Tab label="ALL" />
                                </Tabs>
                                <News shouldShowWeatherNews={this.state.weatherNews}></News>
                            </div>
                        </div>
                    </div>

                    {CommonComponents.getBottomBarComponents()}

                </div>
                <div className="overlay-wrapper">
                    {this.overlayContents()}
                </div>
            </div>
        )
    }

    handleNewsTabChanged = (event, newValue) => {
        if (Utils.isNull(newValue) === true) {
            return;
        }
        var existingValue = (this.state.weatherNews ? 0 : 1)
        if (newValue !== existingValue) {
            this.setState({ weatherNews: newValue === 0 ? true : false })
        }
    };

    handleDailyDataStateChange = (event, newValue) => {
        if (Utils.isNull(newValue) === true) {
            return;
        }
        var existingValue = (this.state.shouldExpandDailyData ? 1 : 0)
        if (newValue !== existingValue) {
            this.setState({ shouldExpandDailyData: newValue === 1 ? true : false })
        }

        Analytics.sendEvent(
            Constants.ANALYTICS.EVENTS.CATEGORY.CLICK,
            Constants.ANALYTICS.EVENTS.ACTION.TOGGLE_WEATHER_FORECAST,
            newValue === 0 ? Constants.ANALYTICS.EVENTS.LABEL.FIVE_DAYS : Constants.ANALYTICS.EVENTS.LABEL.EIGHT_DAYS
        )
    };


    

    getUvIndexTestFor(value) {
        if (value >= 0 && value <= 2) {
            return "Low"
        } else if (value >= 3 && value <= 5) {
            return "Moderate"
        } else if (value >= 6 && value <= 7) {
            return "High"
        } else if (value >= 8 && value <= 10) {
            return "Very High"
        } else if (value >= 11) {
            return "Extreme"
        }
    }

    componentWillUnmount() {
        if (false === Utils.isNull(this.__sidebarListener)) {
            SidebarStateStore.unregisterListenerForKey(this.__sidebarListener)
        }
    }

    // PRAGMA MARK :- Helper methods

    setupBackgroundImage() {
        // Set the background-url
        let currentData = this.props.current_data;
        if (Utils.isNull(currentData)) {
            currentData = {};
        }

        let bgIcon = Constants.DEFAULT_BACKGROUND_URL;
        if (false === Utils.isNull(currentData) && false === Utils.isNull(currentData.icon)) {
            bgIcon = currentData.icon;
        }

        let placeholder = `/image/tiny/${bgIcon}-tiny.jpg`
        let weatherTheme = `bg-theme-${bgIcon}`
        let locationCityInfo = this.props.general_data.location.area_details
        if (Utils.isNull(locationCityInfo)) {
            locationCityInfo = []
            locationCityInfo.city = "Unknown"
        }
        console.log(locationCityInfo);

        var src = DataSource.getItem(locationCityInfo.city + "_" + currentData.icon);
        var imageLoading = false
        if (Utils.isNull(src)) {
            imageLoading = true
            src = `/image/${currentData.icon}/${currentData.icon}${this.state.indexOfImage}.jpg`
            DataSource.setItem(locationCityInfo.city + "_" + currentData.icon, src);
        }

        if (this.state.shouldResetBackground) {
            //{ console.log('imageloading ', imageLoading) }
            return (
                <div className={`bg-image-container ${weatherTheme}`}>
                    <img src={src} className="bg-image bg-image-animate-blur" alt="current-bg" />
                </div>
            )

        } else {
            //console.log('imageloading ', imageLoading)
            if (imageLoading) {
                return (
                    <div className={`bg-image-container ${weatherTheme}`}>

                        <ProgressiveImage src={src} placeholder={placeholder} delay={800}>

                            {(src, loading) => {
                                if (loading) {
                                    console.log("tiny ", src);
                                    return (
                                        <img src={src} className="bg-image bg-image-blur" alt="current-bg" />
                                    )
                                } else {
                                    console.log("new ", src);
                                    this.setState({
                                        shouldResetBackground: true,
                                    })
                                    return (
                                        <img src={src} className="bg-image bg-image-animate-blur" alt="current-bg" />
                                    )
                                }
                            }}
                        </ProgressiveImage>
                    </div>
                )
            } else {
                return (
                    <div className={`bg-image-container ${weatherTheme}`}>
                        <img src={src} className="bg-image" alt="current-bg" />
                    </div>
                )
            }
        }
    }

    getTemperatureUnitImgFromData(currentData) {
        var img = "/image/unit-celcius-v2.svg"
        if (false === Utils.isNull(currentData) && (currentData.temperatureUnit === "F")) {
            img = "/image/unit-fahrenheit-v2.svg"
        }
        return img
    }

    animateRefreshMessage() {
        var updateAnimation = function (shouldShow) {
            // Update the refresh message
            var contentClass = "temp-footnote-content"
            var refreshMsgClass = "temp-footnote-refresh-update"

            var contentElements = document.getElementsByClassName(contentClass)
            var refreshElements = document.getElementsByClassName(refreshMsgClass)

            if (
                false === Utils.isNull(contentElements) && contentElements.length > 0 &&
                false === Utils.isNull(refreshElements) && refreshElements.length > 0
            ) {

                var contentElement = contentElements.item(0)
                var refreshElement = refreshElements.item(0)

                if (shouldShow) {
                    console.log("REFRESH_ANIMATE: footnote hidden")
                    contentElement.classList.remove("show-footnote-content")
                    contentElement.classList.add("hide-footnote-content")

                    refreshElement.classList.add("show-footnote-refresh")
                    refreshElement.classList.remove("hide-footnote-refresh")

                } else {
                    console.log("REFRESH_ANIMATE: footnote shown")
                    refreshElement.classList.remove("show-footnote-refresh")
                    refreshElement.classList.add("hide-footnote-refresh")

                    contentElement.classList.remove("hide-footnote-content")
                    contentElement.classList.add("show-footnote-content")
                }
            }
        }

        // Show the animation
        updateAnimation(true)
        setTimeout(
            () => {
                updateAnimation(false)
            },
            Constants.MIN_REFRESH_TIME_DELTA_MS,
        )
    }

    componentIsDisplayed() {
        // Send the blacklist entries
        setTimeout(() => {
            this.sendNonTappableAreaData()
        }, 500)

        if (false === Utils.isNull(this.props.view_displayed_cb)) {
            this.props.view_displayed_cb();
        }

        if (Utils.isNull(DataSource.getItem("is_first_launch"))) {
            this.firstLaunch = true
            DataSource.setItem("is_first_launch", false)
        }

        // Send analytics events
        Analytics.trackPageView(Constants.ANALYTICS.PAGE_VIEW.WEATHER_PAGE)
        Analytics.sendEvent(
            Constants.ANALYTICS.EVENTS.CATEGORY.COMP_LOAD,
            Constants.ANALYTICS.EVENTS.ACTION.COMP_WEATHER,
            null,
            null,
            true,
        )
    }

    getLatLongStr() {
        if (
            Utils.isNull(this.props.general_data) ||
            Utils.isNull(this.props.general_data.location) ||
            Utils.isNull(this.props.general_data.location.lat) ||
            Utils.isNull(this.props.general_data.location.lon)
        ) {
            return null
        }

        var formattedLatLonStr = Utils.formatLatLon(
            this.props.general_data.location.lat,
            this.props.general_data.location.lon,
        )

        if (Utils.isEmptyStr(formattedLatLonStr)) {
            return null
        }
        return formattedLatLonStr
    }

    getCurrentLocationHtml(currentData) {
        var location = null;
        if (
            false === Utils.isNull(this.props.general_data) &&
            false === Utils.isNull(this.props.general_data.location) &&
            false === Utils.isNull(this.props.general_data.location.area_details)
        ) {
            location = this.props.general_data.location.area_details
        }

        return (
            <div>
                <LocationNotificationView
                    location={location}
                    defaultLocationString={this.getLatLongStr()}
                />
                {/* <LastUpdatedView
                    since={this.props.last_updated_time}
                /> */}
                <div className="timezone-wrapper">
                    {this.getCurrentTimeWithTimezone(this.props.general_data.timezone)} |&nbsp;
                    <LastUpdatedView
                        since={this.props.last_updated_time}
                    />
                </div>
            </div>
        )
    }

    getCurrentTimeWithTimezone(timezone) {
        const moment = require('moment-timezone');
        var m = moment().tz(timezone);
        var formattedDate = m.format('LT');
        //var testDate = m.format('LLLL');
        //var day = moment(testDate).format("Do MMM");
        var timeZone = moment.tz.zone(timezone).abbr(m);
        return formattedDate + " " + timeZone;
    }

    handleChangeStateEvent(e) {
        console.log("Handling state change event!");
        e.preventDefault()
        var currState = this.state.isDailyState;
        this.setState(
            { isDailyState: (!currState) }
        )
    }

    toggleToWeatherNews() {
        Analytics.sendEvent(
            Constants.ANALYTICS.EVENTS.CATEGORY.CLICK,
            Constants.ANALYTICS.EVENTS.ACTION.TOGGLE_NEWS,
            Constants.ANALYTICS.EVENTS.LABEL.NEWS_WEATHER,
        )

        console.log("Handling state change event!")
        if (false === this.state.weatherNews) {
            this.setState(
                { weatherNews: true }
            )
        }
    }

    toggleToAllNews() {
        Analytics.sendEvent(
            Constants.ANALYTICS.EVENTS.CATEGORY.CLICK,
            Constants.ANALYTICS.EVENTS.ACTION.TOGGLE_NEWS,
            Constants.ANALYTICS.EVENTS.LABEL.NEWS_ALL,
        )

        console.log("Handling state change event!")
        if (true === this.state.weatherNews) {
            this.setState(
                { weatherNews: false }
            )
        }
    }

    getBottomEntriesHtml(entryType) {
        var fieldVal;
        var dataList;
        if (entryType === "daily") {
            fieldVal = "timeWeek"
            dataList = this.props.daily_data
        } else {
            fieldVal = "timeHour"
            dataList = this.props.hourly_data
        }
        var dataMap = this.formatEntriesFromListIntoRows(dataList, fieldVal)

        var tdClass = "td-hourly-state ";
        if (fieldVal === "timeWeek") {
            tdClass = "td-daily-state ";
        }
        var toShow = []
        if (entryType === "daily") {
            dataMap.slice(0, this.state.shouldExpandDailyData ? 10 : 5).map((item, key) =>
                toShow.push(
                    <div className={item['isToday'] === true ? "active" : ""} key={key}>
                        <table className="week-info-wrapper">
                            <tbody>
                                <tr key={item['time']}>
                                    <td className={tdClass.concat("week-date-info")} key={"field-" + fieldVal + key}>&zwnj;{daysShortToFullMap[item['time']]}</td>
                                    <td className="date-info">{item['displayDate']}</td>
                                    <td className={tdClass.concat("img-spacing")} key={"icon-" + key}><img className={item['icon']} src={"/image/climate-icons-blue/" + item['icon'] + ".svg"} alt="" /></td>
                                    <td className={tdClass} key={"temp-max" + key}>{item['maxTemp']} &#176;</td>
                                    <td className={tdClass} key={"temp-min" + key}>{item['minTemp']} &#176;</td>
                                </tr>
                            </tbody>
                        </table>
                    </div >
                )
            );
        } else {
            dataMap.map((item, key) => {
                var className = ""
                if (item['isToday'] === true) {
                    className = className + "active";
                }
                if (item['isCurrentTime'] === true) {
                    className = className + " current-time";
                }
                toShow.push(
                    <td className={className} key={key}>
                        <div className={tdClass.concat("week-date-info")} key={"field-" + fieldVal + key}>&zwnj;{item['time']}<br></br><b className="date-info">{item['displayDate']}</b></div>
                        <div className={tdClass.concat("img-spacing")} key={"icon-" + key}><img className={item['icon']} src={"/image/climate-icons-blue/" + item['icon'] + ".svg"} alt="" /></div>
                        <div className={tdClass} key={"temp-" + key}>{item['temperature']}&#176;{item['unit']}</div>
                    </td >
                )
                return null;
            }
            );
        }


        if (entryType === "daily") {
            return (
                <div className="weekly-wrapper">
                    {toShow}
                </div>
            )
        } else {
            return (
                <table className="hourly-wrapper">
                    <tbody>
                        <tr>{toShow}</tr>
                    </tbody>

                </table>
            )
        }
    }

    /**
     * Listens to the on Scroll Listener for the table on the bottom
     */
    onScrollListener() {
        this.setState({
            shouldAutomaticallyScroll: false,
        })
        DataSource.setItem("has_user_manually_scrolled", "yes");
    }

    formatEntriesFromListIntoRows(dataEntries, prop) {
        var dataMap = []
        var currentTimestamp = Math.floor(Date.now() / 1000)
        var today = moment.tz(moment.unix(currentTimestamp), this.props.general_data.timezone).format('MMMM D YYYY');
        var currentHour = moment.tz(moment.unix(currentTimestamp), this.props.general_data.timezone).format('HH');
        for (var entryIndex in dataEntries) {
            var anEntry = []
            var entry = dataEntries[entryIndex];
            anEntry["time"] = entry[prop]
            //If we are showing hourly data, show only those which fall in 24 hrs range for normal user and 48 hrs for premium user
            if (prop === "timeHour" && (entry['time'] - currentTimestamp > (this.props.isPremiumUser? (48 * 60 * 60) : (24 * 60 * 60))|| currentTimestamp - entry['time'] > 1 * 60 * 60)) {
                continue
            }
            var date = moment.tz(moment.unix(entry['time']), this.props.general_data.timezone).format('MMMM D YYYY');
            anEntry['isToday'] = date === today;
            var entriesHour = moment.tz(moment.unix(entry['time']), this.props.general_data.timezone).format('HH');
            anEntry['isCurrentTime'] = currentHour === entriesHour;


            if (prop === "timeWeek") {
                anEntry['timeStamp'] = entry['time']
                anEntry['displayDate'] = moment.tz(moment.unix(entry['time']), this.props.general_data.timezone).format('MMM DD');
            }

            anEntry["minTemp"] = entry['minTemp'];
            anEntry["maxTemp"] = entry['maxTemp'];
            anEntry["temperature"] = entry['currTemp']
            if (anEntry['isCurrentTime'] === true) {//If the time is same, override with currently data
                anEntry["temperature"] = this.props.current_data.currTemp;
            }
            anEntry["unit"] = entry["temperatureUnit"]

            var iconVal = entry.icon
            if (typeof (iconVal) === "undefined" || iconVal === null || iconVal === "") {
                iconVal = DEFAULT_ICON
            }
            anEntry["icon"] = iconVal
            dataMap.push(anEntry)
        }
        return dataMap
    }


    sendTempDetailsToClient() {
        var currentData = this.props.current_data;
        if (typeof (currentData) === "undefined" || currentData === null) {
            console.log("IFRAME: Could not send any data into iframe")
            return (<span></span>)
        }
        var url = "inapp://data/" + currentData.icon + "/" + currentData.currTemp + "/" + currentData.temperatureUnit;
        console.log("IFRAME: Sending url  - " + url);
        return (
            <iframe src={url} style={{ display: "none" }} title={url} />
        )
    }

    handleCurrTempClick(e) {
        console.log("curr temp clicked!")
        if (Utils.isNull(this.props.si_unit_toggle)) {
            console.log("Could not handle curr-temp-click since the si_unit_toggle prop is empty!")
            return;
        }
        this.props.si_unit_toggle()

        if (true === this.state.showToolTip) {
            this.hideTooltip();
        }

        this.setState({
            showToolTip: false
        })
    }

    toolTipClickedEvent() {
        if (false === Utils.isNull(this.props.tool_tip_clicked_cb)) {
            console.log("TOOLTIP: Clicked cb!")
            this.props.tool_tip_clicked_cb()
        }
    }

    sendNonTappableAreaData() {
        // classname list
        var blackListClassNames = [
            "hourly-wrapper",
            "search-wrap",
            "table-news-scroll"
        ];

        let boxListStr = DomUtils.getBoundingBoxListStrForClassNames(blackListClassNames, this.scrollTop)
        if (Utils.isEmptyStr(boxListStr)) {
            return
        }

        // Pushing box list into native-client
        NativeAgent.addBlackListBounds(boxListStr)
    }

    getTooltipContent() {
        if (false === this.state.showToolTip) {
            return (<span></span>)
        }

        // Theme change for tooltip
        var toolTipFlavor = Theme.getThemeToolTipFlavor()
        if (false === Utils.isNull(this.toolTipRemovalHandlerTimeout)) {
            clearTimeout(this.toolTipRemovalHandlerTimeout)
        }
        this.toolTipRemovalHandlerTimeout = setTimeout(
            () => {
                this.hideTooltip();
            },
            Constants.DEFAULT_TOOL_TIP_TIMEOUT_MS,
        )

        return (
            <div className={"temperature-tooltip-wrapper " + toolTipFlavor}>
                <div className={"temperature-tooltip-arrow " + toolTipFlavor + "-arrow"}>
                </div>
                <div className="temperature-tooltip">
                    <div className="temperature-tooltip-content">
                        Click to change the units
                    </div>
                </div>
            </div>
        )
    }

    hideTooltip() {
        this.setState({
            showToolTip: false,
        })
        this.toolTipClickedEvent()
        if (false === Utils.isNull(this.toolTipRemovalHandlerTimeout)) {
            clearTimeout(this.toolTipRemovalHandlerTimeout)
        }
    }

    // Handle display location selector click
    handleDisplayLocationSelClick() {
        console.log("Clicked!");
        this.setState({
            showLocationPickerOverlay: true
        })
    }

    // Add overlay layout
    overlayContents() {
        if (false === this.state.showLocationPickerOverlay) {
            return (<span></span>)
        }
        return (
            <div className={"overlay-content " + Theme.getThemeBodyClass()}>
                <LocationFinder
                    is_back_enabled={true}
                    back_press_callback={() => {
                        console.log("Pressed back!")
                        this.hideOverlay()
                    }}
                    on_location_selected={(newLocation) => {
                        this.props.on_new_location_selected_from_finder(newLocation)
                        this.hideOverlay()
                    }}
                />
            </div>
        )
    }

    hideOverlay() {
        this.setState({
            showLocationPickerOverlay: false
        })

        this.componentIsDisplayed()
    }

    // PRAGMA-MARK :- Sidebar status
    sidebarStatusHandler() {
        // Call the black-list only when the sidebar is closed
        if (false === SidebarStateStore.getIsSidebarOpen()) {
            console.log("BOUNDING-BOX: Calling from weather-view")
            this.sendNonTappableAreaData()
        }
    }
}

WeatherView.propTypes = {
    original_data: PropTypes.any.isRequired,
    general_data: PropTypes.any.isRequired,
    current_data: PropTypes.any.isRequired,
    daily_data: PropTypes.any.isRequired,
    hourly_data: PropTypes.any.isRequired,
    show_tool_tip: PropTypes.bool.isRequired,
    tool_tip_clicked_cb: PropTypes.any.isRequired,
    is_detect_location_notification_show: PropTypes.bool.isRequired,
    on_new_location_selected_from_finder: PropTypes.func.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/weather/weatherView.js